export default "/images/vendor/flag-icon-css/flags/4x3/fo.svg?7c11a8ad56937ca0487c01e6558bcd03";